import { Button } from "@material-ui/core";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import { ReactComponent as GroupManagementIcon } from "../../assets/images/groupManagement.svg";
import { GROUPS_MANAGEMENT_URL } from "../../const/URL.const";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      textDecoration: "none",
    },
    button: {
      margin: "0 1rem",
      backgroundColor: "#E8EAF4!important",
      "&:hover": {
        "& .logoutSVG path": {
          stroke: "#ffffff",
          transition: "stroke 0.3s ease",
        },
      },
      "&:active": {
        backgroundColor: "unset!important",
      },
    },
    title: {
      marginLeft: "0.5rem",
      fontFamily: "Open Sans",
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "0.875rem",
      color: "#455681",
      display: "flex",
      justifyContent: "center",
      lineHeight: "0.875rem",
      "@media (max-width: 600px)": {
        display: "none",
      },
    },
    groupManagementBtn:{
      backgroundColor: "transparent!important",
      margin:"0 .2rem",
      "& svg":{
        width:"2.5rem!important",
        height:"2.5rem!important"
      }

    }
  })
);

const GroupsManagementButton = () => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <div>
      <Button
        id="groupSettingsButton"
        className={classes.groupManagementBtn}
        name="groupManagement"
        aria-label="groupSettings"
        data-component-name = {"GroupManagementBtn"}
        onClick={() =>{
          history.push(GROUPS_MANAGEMENT_URL)
        }}
      >
        <GroupManagementIcon width={"2.5rem!important"} height={"2.5rem!important"}/>

      </Button>
    </div>
  );
};

export default GroupsManagementButton;
